module.exports = __webpack_public_path__ + "static/media/pick-up-delivery.9dd70921.svg";